import { format, utcToZonedTime } from 'date-fns-tz';
import { ISO_DATE } from '@/utils/dateFormats';

export default {
  SET_ALTERACOES(state, payload) {
    if (payload.length) {
      if (payload.at(-1).eta) {
        const zonedDate = utcToZonedTime(new Date(payload.at(-1).eta), 'Etc/UTC');

        payload.at(-1).eta = format(zonedDate, ISO_DATE);
      }

      if (payload.at(-1).etd) {
        const zonedDate = utcToZonedTime(new Date(payload.at(-1).etd), 'Etc/UTC');

        payload.at(-1).etd = format(zonedDate, ISO_DATE);
      }
    }

    state.alteracoes = payload;
  },
};
